var canDrag;
export function getCanDrag() {
  if (!canDrag) {
    canDrag = typeof FileReader !== 'undefined' || isBrowser('safari') && isBrowser('mac');
  }
  return canDrag;
}
export function throwIfDirectoryUploadIsNotAvailable() {
  if (!window.DataTransferItem || window.Directory || !('webkitdirectory' in document.createElement('input') && 'webkitGetAsEntry' in DataTransferItem.prototype)) {
    return;
  }
  throw new Error('You must include a polyfill for Directory Upload. You can find the recommended polyfill here: https://github.com/WICG/directory-upload/blob/gh-pages/polyfill.js');
}
export function isBrowser(userAgent) {
  return navigator.userAgent.toLowerCase().includes(userAgent);
}
export function isMSEdge() {
  return /Edge\/([0-9]+)\./.test(navigator.userAgent);
}
export function getChromeVersion() {
  var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  return raw ? parseInt(raw[2], 10) : -1;
}
export function supportsFolderUpload() {
  return typeof DataTransfer !== 'undefined' && 'getFilesAndDirectories' in DataTransfer.prototype;
}
export var operatingSystem = /*#__PURE__*/function (operatingSystem) {
  operatingSystem[operatingSystem["windows"] = 0] = "windows";
  operatingSystem[operatingSystem["mac"] = 1] = "mac";
  operatingSystem[operatingSystem["android"] = 2] = "android";
  operatingSystem[operatingSystem["ios"] = 3] = "ios";
  operatingSystem[operatingSystem["linux"] = 4] = "linux";
  operatingSystem[operatingSystem["other"] = 5] = "other";
  return operatingSystem;
}({});
var operatinSystemChecks = [{
  test: /linux/,
  operatingSystem: operatingSystem.linux
}, {
  test: /mac os x/,
  operatingSystem: operatingSystem.mac
}, {
  test: /os.*like mac os/,
  operatingSystem: operatingSystem.ios
}, {
  test: /android/,
  operatingSystem: operatingSystem.android
}, {
  test: /windows/,
  operatingSystem: operatingSystem.windows
}];
export function getOperatingSystem() {
  var userAgent = navigator.userAgent.toLowerCase();
  var os = operatingSystem.other;
  operatinSystemChecks.forEach(function (check) {
    if (check.test.test(userAgent)) {
      os = check.operatingSystem;
    }
  });
  return os;
}
export function isOperatingSystem(os) {
  return operatinSystemChecks.filter(function (check) {
    return check.operatingSystem === os;
  }).every(function (check) {
    return check.test.test(navigator.userAgent.toLowerCase());
  });
}
export var isIOS = function isIOS() {
  return isOperatingSystem(operatingSystem.ios);
};
export var isMacOS = function isMacOS() {
  return isOperatingSystem(operatingSystem.mac) && !isIOS();
};